import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const storedLogin = sessionStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(storedLogin);
  }, []);

  const login = (token, userId) => {
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('userId', userId);
    setIsLoggedIn(true);
  };

  const logout = () => {
    sessionStorage.clear();
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
